(function () {
    'use strict';

    angular.module('doclr.beschikbaarheidtypes', ['doclr.resources.api', 'doclr.components.notification', 'doclr.components.colorselector', 'ui.router', 'doclr.disciplines'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('beschikbaarheidtypes', {
                    url: '/beschikbaarheid-types/:typeId',

                    resolve: {
                        disciplineList: function (Disciplines) {
                            return Disciplines.getList();
                        },
                        types: function (EditableBeschikbaarheidTypes, praktijkContext) {
                            return EditableBeschikbaarheidTypes.getList(praktijkContext.id).then(function (types) {
                                return _.sortBy(types, function (type) {
                                    return type.editeerbaar ? 0 : 1;
                                });
                            });
                        },
                        type: function ($stateParams, EditableBeschikbaarheidTypes, types, praktijkContext) {
                            var standaardAdresId = praktijkContext.adressen.filter(function (adres) {
                                return adres.standaard;
                            })[0].id;
                            if ($stateParams.typeId === 'nieuw' || types.length === 0) {
                                return {
                                    eventType: 'afspraakMogelijkheid',
                                    zichtbaarVoorPatient: 'ja',
                                    editeerbaar: true,
                                    metAfspraakmogelijkheden: false,
                                    invulbaarDoorPatient: false,
                                    kleur: '#bee0f9',
                                    metEmail: false,
                                    praktijkAdresId: standaardAdresId,
                                    isActive: true
                                };
                            } else if ($stateParams.typeId) {
                                return EditableBeschikbaarheidTypes.load(decodeURIComponent(decodeURIComponent($stateParams.typeId)));
                            } else {
                                return EditableBeschikbaarheidTypes.load(types[0].id);
                            }
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.large.margin.html',
                            controller: function ($scope, $state, $window) {
                                $scope.goToDetail = function (typeId) {
                                    $state.go('beschikbaarheidtypes', {typeId: typeId ? encodeURIComponent(encodeURIComponent(typeId)) : null}, {reload: true});
                                    $window.scroll({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                };
                            }
                        },
                        'sidebar@beschikbaarheidtypes': {
                            templateUrl: '/partials/beschikbaarheidtypes/beschikbaarheidtypes.sidebar.html',
                            controller: function ($scope, $state, types, type, borderColor, groupByKey, sortByProperty) {
                                $scope.showInactive = false;
                                $scope.types = types;

                                let activeTypes = types.filter(type => !!type.isActive);
                                let inactiveTypes = types.filter(type => !type.isActive);

                                $scope.groupedActiveTypes = groupAppointmentTypes(activeTypes);
                                $scope.groupedInActiveTypes = groupAppointmentTypes(inactiveTypes);

                                $scope.currentType = type;

                                $scope.isActiefType = function (type) {
                                    return $scope.currentType.id === type.id;
                                };

                                $scope.toggleInactiveTypes = () => $scope.showInactive = !$scope.showInactive;

                                $scope.borderColor = borderColor;

                                $scope.createNew = function () {
                                    $scope.goToDetail('nieuw');
                                };

                                function groupAppointmentTypes(appointmentTypes) {
                                    return groupByKey(appointmentTypes, (type) => type.disciplineName)
                                        .map(group => {
                                            return {
                                                disciplineName: group.key,
                                                types: group.values.sort(sortByProperty(x => doclrVertaal.translateType(x)))
                                            }
                                        })
                                        .sort(sortByProperty(x => x.disciplineName));
                                }
                            }
                        },
                        'content@beschikbaarheidtypes': {
                            templateUrl: '/partials/beschikbaarheidtypes/beschikbaarheidtypes.detail.html',
                            resolve: {
                                praktijk: function (Praktijk, praktijkContext) {
                                    return Praktijk.getInfo(praktijkContext.id);
                                },
                                mailOntvangers: function (EditableBeschikbaarheidTypes, praktijkContext, type) {
                                    return EditableBeschikbaarheidTypes.getMailOntvangers(type.id, praktijkContext.id);
                                }
                            },
                            controller: function ($state,
                                                  $scope,
                                                  disciplineList,
                                                  EditableBeschikbaarheidTypes,
                                                  notificationService,
                                                  praktijkContext,
                                                  praktijk,
                                                  type,
                                                  $uibModal,
                                                  mailOntvangers,
                                                  supportedLanguages,
                                                  DoclrModalService) {
                                $scope.disciplineList = disciplineList;
                                $scope.eventTypes = ['afspraakMogelijkheid', 'beschikbaarheid']
                                $scope.type = type;
                                $scope.praktijk = praktijk;
                                $scope.praktijkContext = praktijkContext;
                                $scope.isNieuwType = function () {
                                    return !$scope.type.id;
                                };

                                $scope.makeDefault = function () {
                                    DoclrModalService.openConfirmModal(
                                        doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.make.default.popup.title'),
                                        doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.make.default.popup.question'))
                                        .then(() => EditableBeschikbaarheidTypes.setDefault(praktijkContext.id, type.id))
                                        .then(() => $scope.goToDetail(type.id));
                                }

                                type.mailOntvangers = mailOntvangers;

                                $scope.bewaren = function () {
                                    if (!$scope.isNieuwType()) {
                                        EditableBeschikbaarheidTypes.saveWijzigingen(type).then(function () {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeUdated'));
                                            $scope.goToDetail(type.id);
                                        });
                                    } else {
                                        EditableBeschikbaarheidTypes.saveNieuwType(praktijkContext.id, type).then(function (nieuweType) {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeCreated'));
                                            $scope.goToDetail(nieuweType.id);
                                        });
                                    }
                                };

                                $scope.verwijderen = function () {
                                    $scope.confirmmodal = {
                                        title: doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.deleteTypeTitle'),
                                        question: doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.deleteTypeQuestion', {name: type.naam})
                                    };

                                    var modalInstance = $uibModal.open({
                                        templateUrl: '/partials/components/confirmmodal.html',
                                        scope: $scope
                                    });

                                    modalInstance.result.then(function () {
                                        EditableBeschikbaarheidTypes.verwijder(type).then(
                                            function () {
                                                notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeDeleted'));
                                                $state.go('beschikbaarheidtypes', {typeId: null});
                                            }
                                        );
                                    });
                                };

                                $scope.reload = function () {
                                    $scope.goToDetail($scope.type.id);
                                };
                            }
                        }
                    }

                });
        });
})();